class SecureLink {

  constructor(event, filename, asset) {

    event.preventDefault()

    if ( asset == 'undefined' ) { return }

    let modal = new Modal()
        
    let settings = {
      template : '_components/modals/secure-download.twig',
      asset    : asset,
      filename : filename,
      type     : 'secure-download'
    }

    fetcher.get('/fetch-template', settings, {
      success : (response) => {
        modal.open(response.html, (modal) => {
          let form = modal.querySelector('form');

          if ( form ) {

            let freeform = Freeform.getInstance(form)
            
            // Do something on a successful ajax submit
            freeform.addOnSuccessfulAjaxSubmit(function(event, form, response) {
              // Redirect the user
              let container = form.parentNode;
              container.classList.add('success')
              
              container.insertAdjacentHTML('afterend', `
              <div class="message">
                <h3>An email is on its way.</h3>
                <p>Check your emails to download <span>"${filename}"</span><br>It may take 5-10 minutes for the mail to get to you.</p>
                <svg class="icon-email" role="img" data-icon="email"><use xlink:href="#icon-email"></use></svg>
              </div>
               `);
            })

            // Do something on a failed ajax submit
            freeform.addOnFailedAjaxSubmit(function(event, form, response) {
              // Do whatever checks on errors you need to do, if any
              var errors = response.errors;

              let container = form.parentNode;
              container.classList.add('error')
              
              container.insertAdjacentHTML('afterend', `
              <div class="message">
                <h3>There was a problem.</h3>
                <p>${errors}</p>
              </div>
               `);
            })

            
          }
        })
      },
      error : (response) => {
        console.log('ERROR', response);

      }
    })


  }

}